import { Link } from "react-router-dom";
import { Briefcase, UserRound } from "lucide-react";
import { Logo } from "@/components/Logo";
import { rememberSpace } from "@/lib/pwa";

/** Écran de choix d'espace (PWA sans contexte mémorisé, ou accès direct). Une seule application Respondia, deux espaces. */
export default function SpaceChooser() {
  return <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-6" data-testid="space-chooser">
    <Logo />
    <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight mt-8 text-center">Quel espace souhaitez-vous ouvrir ?</h1>
    <p className="text-slate-500 text-sm mt-2 text-center max-w-sm">Respondia mémorisera votre choix pour les prochains lancements. Vous pourrez toujours changer d'espace depuis l'écran de connexion.</p>
    <div className="grid gap-3 w-full max-w-sm mt-8">
      <Link to="/login" onClick={() => rememberSpace("employer")} className="flex items-center gap-4 rounded-2xl bg-blue-600 text-white p-5 min-h-[72px] hover:bg-blue-700 transition-colors" data-testid="space-employer">
        <Briefcase className="w-7 h-7 shrink-0" /><div><div className="font-semibold">Connexion Employeur</div><div className="text-xs text-white/80">Dirigeant, responsable, administrateur</div></div>
      </Link>
      <Link to="/salarie/connexion" onClick={() => rememberSpace("employee")} className="flex items-center gap-4 rounded-2xl bg-slate-900 text-white p-5 min-h-[72px] hover:bg-slate-800 transition-colors" data-testid="space-employee">
        <UserRound className="w-7 h-7 shrink-0" /><div><div className="font-semibold">Espace Salarié</div><div className="text-xs text-white/80">Planning, pointage, commandes, messages, documents</div></div>
      </Link>
    </div>
    <Link to="/?site=1" className="text-xs text-slate-400 underline mt-8" data-testid="space-site">Découvrir Respondia</Link>
  </div>;
}
